import { Card, Typography, SxProps } from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/Colors.js";
import PrimaryButton from "../Common/PrimaryButton.tsx";
import { ComponentConfig } from "../../Config/ComponentConfig.js";

// Interface for props
interface AppointmentDocumentsProps {
  documentTitle?: string;
  textColor?: string;
  onButtonTap: () => void;
  buttonTitle?: string;
  backgroundColor?: string;
  buttonBackgroundColor?: string;
  sx?: SxProps;
}

const AppointmentDocuments: React.FC<AppointmentDocumentsProps> = ({
  documentTitle = "Invoice",
  textColor,
  onButtonTap,
  buttonTitle = "Download",
  backgroundColor,
  buttonBackgroundColor,
  sx,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        position: "relative",
        width: "100%",
        padding: "14px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: backgroundColor ?? Colors.primaryOrange,
          opacity: 0.08,
          borderRadius: "inherit",
          zIndex: 0,
        },
        "& > *": {
          position: "relative",
          zIndex: 1,
        },
        ...sx,
      }}
    >
      {/* Document Title */}
      <Typography
        color={textColor ?? Colors.primaryOrange}
        fontSize={ComponentConfig.fonts.smallBold}
        fontWeight={ComponentConfig.fonts.smallBold.fontWeight}
      >
        {documentTitle}
      </Typography>

      {/* Primary Button with custom title and action */}
      <PrimaryButton
        text={buttonTitle}
        fullWidth={false}
        textClassName="body-regular"
        backgroundColor={buttonBackgroundColor ?? Colors.primaryOrange}
        textColor={Colors.white}
        onTap={onButtonTap}
        sx={{
          padding: "14px 20px",
        }}
        endIcon={
          <img
            src="/icons/download_icon.svg"
            alt="Custom Icon"
            style={{ width: 20, height: 20 }}
          />
        }
      />
    </Card>
  );
};

export default AppointmentDocuments;
